<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<div class="d-flex justify-content-between align-items-center mt-3 ms-1 mb-3 w-100">
  <div>
    <h3 class="m-0">Nuovo prodotto/servizio</h3>
    <p class="m-0 text-muted">
      Le prestazioni salvate saranno disponibili durante la creazione di nuove fatture o preventivi.
    </p>
  </div>
</div>

<p class="ms-1 small text-muted">
  I campi contrassegnati da * sono obbligatori.
</p>

<form
  #SavedProductForm="ngForm"
  class="savedproduct-form"
  (ngSubmit)="onSubmit()"
  >

<mat-card class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl">
  <mat-card-content>

        <h5 class="mb-3">Inserisci i dati:</h5>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Nome</mat-label>
            <input
              matInput
              [(ngModel)]="newSavedProduct.name"
              name="name"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Tipo</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newSavedProduct.type"
              name="type"
              required
            >
              <mat-option *ngFor="let type of typeOptions" [value]="type.code">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Unità di misura</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newSavedProduct.units"
              name="units"
            />
          </mat-form-field>

        </div>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Descrizione</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newSavedProduct.description"
              name="description"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Prezzo unitario</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="newSavedProduct.unit_price"
              name="unit_price"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Percentuale IVA</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="newSavedProduct.iva_percentage"
              name="iva_percentage"
              disabled
            />
          </mat-form-field>
        </div>

        <!-- .hidden-mobile impone display:block, quindi l'allineamento a destra
             passa da text-end (il pulsante e' inline-flex) e non da flexbox. -->
        <div class="text-end hidden-mobile">
          <button
            mat-raised-button
            matButton="filled"
            type="submit"
            [disabled]="!SavedProductForm.valid"
            class="mt-2 primary-button custom-button-border"
          >
            <mat-icon>save</mat-icon>
            Salva
          </button>
        </div>
        <!-- mobile version -->
        <div class="visible-mobile">
          <button
            mat-raised-button
            matButton="filled"
            type="submit"
            [disabled]="!SavedProductForm.valid"
            class="w-100 mt-2 primary-button custom-button-border"
          >
            <mat-icon>save</mat-icon>
            Salva
          </button>
        </div>

  </mat-card-content>
</mat-card>


</form>

<div class="pt-3 mb-3"></div>
